// extracted by mini-css-extract-plugin
export default {"container":"Logo_container__GBlms","mainContainer":"Logo_mainContainer__qtGS+"};